import { render, staticRenderFns } from "./DeleteTypeAnnonce.vue?vue&type=template&id=2c17460d&"
import script from "./DeleteTypeAnnonce.vue?vue&type=script&lang=js&"
export * from "./DeleteTypeAnnonce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports